import Vue from 'vue'
import NewApp from './new/App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import "./filters"
import Multiselect from 'vue-multiselect'
import VueToastr2 from 'vue-toastr-2'
import VueI18n from 'vue-i18n'
import VueAnalytics from 'vue-analytics'

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
    console.log(e);
}

const isProd = process.env.NODE_ENV === 'production';

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['api-version'] = '2';
window.axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL; //(! isProd) ? 'https://api.ufinance.test/' : 'https://api.ufin.me/';

window.axios.interceptors.response.use((response) => response, (error) => {
    if(error.response.status === 403 && error.response.data.message === 'Unauthenticated.') {
        localStorage.removeItem('token');
        location.reload();
    }

    throw error;
});

Vue.prototype.$http = axios;

const token = localStorage.getItem('token');

if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// import 'bootstrap/scss/bootstrap.scss';

// import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
// import "@fortawesome/fontawesome-free/scss/brands.scss";
// import "@fortawesome/fontawesome-free/scss/solid.scss";

import "vue-multiselect/dist/vue-multiselect.min.css";
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import './assets/scss/new.scss';

Vue.config.productionTip = false;

window.toastr = require('toastr');

Vue.component('multiselect', Multiselect);
Vue.use(VueToastr2);
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'uk',
    fallbackLocale: 'uk',
});

function setI18NLanguage() {
    let lang = store.state.language;

    i18n.locale = lang;
    window.axios.defaults.headers.common['Accept-Language'] = lang;
    store.state.translations = JSON.parse(localStorage.getItem('translations'))[lang];
    i18n.setLocaleMessage(lang, store.state.translations);
    
    return lang;
}

window.setI18NLanguage = setI18NLanguage;

if(! localStorage.getItem('translations') || ! isProd || true) {
    axios.get('/translations')
        .then(({data}) => {
            localStorage.setItem('translations', JSON.stringify(data.data));

            setI18NLanguage();
        });
} else {
    setI18NLanguage();
}

Vue.use(VueAnalytics, {
    id: 'UA-151757798-2',
    checkDuplicatedScript: true,
    router,
    debug: {
        enabled: ! isProd,
        sendHitTask: isProd,
    },
    commands: {
        newTransactionModalButton(label = "dashboard") {
            this.$ga.event('newTransactionModalButton', 'click', label);
        }
    }
});

console.log(`Current Version: ${process.env.VUE_APP_VERSION}`);

new Vue({
    router,
    i18n,
    store,
    render: h => h(NewApp)
}).$mount('#app');